import api from './client';

export interface QuizCard {
  question: string;
  options: string[];
}

export interface StartQuizResponse {
  quiz_id: string;
  total_budget: number;
  current_question: number;
  card: QuizCard;
  category_name: string;
  category_level: number;
}

export interface AnswerQuizResponse {
  correct: boolean;
  current_question: number;
  questions_remaining: number;
  quiz_complete: boolean;
  next_card?: QuizCard;
  next_category_name?: string;
  next_category_level?: number;
  placement_category_name?: string;
  categories_remaining?: number;
  message?: string;
}

export const startPlacementQuiz = async (): Promise<StartQuizResponse> => {
  const res = await api.post('/api/quiz/placement/start');
  return res.data;
};

export const answerPlacementQuiz = async (quizId: string, answer: string): Promise<AnswerQuizResponse> => {
  const res = await api.post('/api/quiz/placement/answer', {
    quiz_id: quizId,
    answer,
  });
  return res.data;
};
